import { initReactI18next } from 'react-i18next';

import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import * as ko from './ko';
import * as en from './en';

const resources = {
  ko: {
    ...ko,
  },
  en: {
    ...en,
  },
} as const;

i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    load: 'languageOnly',
    supportedLngs: ['ko', 'en'],
    // 언어 코드는 언어만 사용하고, 키는 점(.) 구분자로 중첩 접근을 허용
    fallbackLng: ['ko', 'en'],
    keySeparator: '.',
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18next;
